import { matchPath } from "react-router-dom";
import history from "utils/history";
import type { TourDefinition } from "../types/tour.types";

const PARAM_PATTERN = /:([A-Za-z0-9_]+)/g;

export const hasRouteParams = (route: string): boolean => route.includes(":");

export const buildPath = (
  route: string,
  params: Record<string, string>,
): string =>
  route.replace(PARAM_PATTERN, (_full, name: string) =>
    encodeURIComponent(params[name] ?? ""),
  );

export const isRouteActive = (route: string, pathname: string): boolean =>
  Boolean(matchPath(pathname, { path: route, exact: true }));

export const currentPathname = (): string => history.location.pathname;

const tourRoutes = (tour: TourDefinition): string[] => {
  const seen = new Set<string>();
  const routes: string[] = [];
  tour.steps.forEach((step) => {
    const route = step.route ?? tour.route;
    if (!seen.has(route)) {
      seen.add(route);
      routes.push(route);
    }
  });
  return routes.length > 0 ? routes : [tour.route];
};

const isTourAvailableOn = (tour: TourDefinition, pathname: string): boolean =>
  tourRoutes(tour).some((route) => isRouteActive(route, pathname));

export const toursForRoute = (
  tours: TourDefinition[],
  pathname: string,
): TourDefinition[] =>
  tours.filter((tour) => isTourAvailableOn(tour, pathname));
